import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { GripVertical, XCircle } from 'lucide-react';

export function TemplatesSidebar({ shiftTemplates, show, onClose, onDragStart, onDragEnd }) {
  if (!show || shiftTemplates.length === 0) return null;

  return (
    <Card className="fixed right-4 top-24 w-64 z-40 shadow-lg border-slate-200 max-h-[calc(100vh-120px)] overflow-hidden flex flex-col">
      <CardHeader className="p-3 pb-2 border-b border-slate-100 flex-shrink-0">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-semibold text-slate-900 flex items-center gap-2">
            <GripVertical size={14} className="text-slate-400" />
            Shift Templates
          </CardTitle>
          <Button variant="ghost" size="icon" className="h-6 w-6" onClick={onClose}>
            <XCircle size={14} />
          </Button>
        </div>
        <p className="text-xs text-slate-500 mt-1">Drag onto schedule to create shift</p>
      </CardHeader>
      <CardContent className="p-2 overflow-y-auto flex-1">
        <div className="space-y-1.5">
          {shiftTemplates.map((template) => (
            <div
              key={template.id}
              draggable
              onDragStart={(e) => onDragStart(e, template)}
              onDragEnd={onDragEnd}
              className="p-2 rounded border border-slate-200 bg-white hover:bg-slate-50 cursor-grab active:cursor-grabbing transition-colors"
              style={{ borderLeftWidth: '3px', borderLeftColor: template.role_color || template.color || '#94a3b8' }}
            >
              <div className="text-sm font-medium text-slate-900">{template.name}</div>
              <div className="text-xs text-slate-500">{template.start_time} - {template.end_time}</div>
              {template.role_name && (
                <div className="text-xs font-medium mt-0.5" style={{ color: template.role_color || '#64748b' }}>
                  {template.role_name}
                </div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
